import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const emptyOrWhitespaceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (value === null || value === undefined || typeof value !== 'string') {
    return null;
  }

  const isRequired = control.hasValidator?.(Validators.required);

  if (isRequired && value.trim().length === 0) {
    return { required: true };
  }

  return null;
};
